import React, { useState } from "react";
import { Link } from "react-router-dom";
import toast from "react-hot-toast";
import { useForm } from "react-hook-form";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";

const ForgotPasswordComponent = () => {
  const [isSubmitted, setIsSubmitted] = useState(false);

  const schema = Yup.object().shape({
    email: Yup.string().email().required(),
  });

  const {
    register,
    handleSubmit,
    formState: { errors, isDirty, isValid },
  } = useForm({
    mode: "all",
    resolver: yupResolver(schema),
  });

  const onSubmit = async (data) => {
    setIsSubmitted(true);

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/forgot-password`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        }
      );

      const jsonData = await response.json();

      if (response.ok) {
        toast.success(jsonData.message);
      } else {
        toast.error(jsonData.message);
      }
    } catch (error) {
      const errorMessage = error.message || "An error occurred";
      toast.error(errorMessage);
    }
    setIsSubmitted(false);
  };

  return (
    <div className="account-page">
      <div className="main-wrapper">
        <div className="account-content">
          <div className="container">
            <div className="account-logo">
              <img src="assets/img/logo.png" alt="Visions" />
            </div>

            <div className="account-box">
              <div className="account-wrapper">
                <h3 className="account-title">Forgot Password?</h3>
                <p className="account-subtitle">
                  Enter your email to get a password reset link
                </p>

                <form onSubmit={handleSubmit(onSubmit)}>
                  <div className="input-block mb-4">
                    <label className="col-form-label">Email Address</label>
                    <input
                      className="form-control"
                      type="text"
                      {...register("email")}
                    />
                    <div className="form-text text-danger">
                      {errors.email && <p>{errors.email.message}</p>}
                    </div>
                  </div>
                  <div className="input-block  text-center">
                    <button
                      type="submit"
                      disabled={isSubmitted || !isDirty || !isValid}
                      className="btn btn-primary account-btn"
                    >
                      Reset Password
                    </button>
                  </div>
                  <div className="account-footer">
                    <p>
                      Remember your password? <Link to="/">Login</Link>
                    </p>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordComponent;
